import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import { MenuItem } from 'material-ui/Menu';
import SearchIcon from 'material-ui-icons/Search';
import { withStyles } from 'material-ui/styles';

const styles = {
  container: {
    flexGrow: 1,
    width: 200,
    float: 'left',
    height: 40,
    marginRight: 0,
  },
  textField: {
    width: 150,
    height: 40,
    float: 'left',
  },
  search: {
    float: 'left',
  },
};

class IntegrationAutosuggest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
    });
  };

  renderInput(inputProps) {
    const { classes, autoFocus, value, ref, ...other } = inputProps;

    return (
      <div>
        <div className={classes.search}>
          <SearchIcon style={{ height: 40 }} />
        </div>
        <TextField
          autoFocus={autoFocus}
          className={classes.textField}
          value={this.state.value}
          InputProps={{
            classes: {
              input: classes.input,
            },
            ...other,
          }}
        />
      </div>
    );
  }

  renderSuggestion(params) {
    const { suggestion, index, itemProps, theme, highlightedIndex, selectedItem } = params;
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem === suggestion.label;

    return (
      <MenuItem
        {...itemProps}
        key={suggestion.id}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
        }}
        onClick={() => this.setSelect(suggestion)}
      >
        {suggestion.label}
      </MenuItem>
    );
  }

  setSelect(suggestion) {
    this.downshift.closeMenu();
    this.setState({ value: '' });
    this.props.getSelected(suggestion);
  }

  renderSuggestionsContainer(options) {
    const { containerProps, children } = options;

    return (
      <Paper {...containerProps} square>
        <div style={{ clear: 'both' }} />
        {children}
      </Paper>
    );
  }

  getSuggestions(inputValue, suggestions) {
    let count = 0;

    return suggestions.filter(suggestion => {
      const keep =
        (suggestion.label && (!inputValue || suggestion.label.toLowerCase().includes(inputValue.toLowerCase()))) &&
        count < 5;

      if (keep) {
        count += 1;
      }

      return keep;
    });
  }

  render() {
    const { classes, theme, nodes } = this.props;

    return (
      <Downshift
        ref={(down) => { this.downshift = down; }}
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex,
        }) => (
          <div className={classes.container}>
            {this.renderInput(
              getInputProps({
                classes,
                placeholder: 'Search',
                id: 'integration-downshift',
                onChange: this.handleChange,
              }),
            )}
            {isOpen
              ? this.renderSuggestionsContainer({
                children: this.getSuggestions(inputValue, nodes).map((suggestion, index) =>
                  this.renderSuggestion({
                    suggestion,
                    index,
                    theme,
                    itemProps: getItemProps({ item: suggestion.label }),
                    highlightedIndex,
                    selectedItem,
                  }),
                ),
              })
              : null}
          </div>
        )}
      />
    );
  }
}

IntegrationAutosuggest.propTypes = {
  classes: PropTypes.object.isRequired,
  getSelected: PropTypes.func.isRequired,
  nodes: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(IntegrationAutosuggest);



// WEBPACK FOOTER //
// ./scripts/components/IntegrationAutosuggest.jsx